<ion-card class="card-container">
  <ion-card-content>
    <div data-cy="contact-information-title-div" class="header-info">
      <h2>{{ 'i18n.profilePage.contact.title' | translate }}</h2>
      <h3>
        {{
          (isMobile
            ? 'i18n.profilePage.contact.subtitleMobile'
            : 'i18n.profilePage.contact.subtitle'
          ) | translate
        }}
      </h3>
    </div>
    <div data-cy="contact-information-form" class="card-content">
      <form [formGroup]="contactForm" (ngSubmit)="validateSubmit()">
        <ion-grid>
          <ion-row class="ion-justify-content-between">
            <ion-col
              data-cy="first-name-input-field"
              class="contact-input"
              size="12"
              size-md="3.5"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
                [class.error]="contactForm.get('firstName').invalid"
                [class.update]="contactForm.get('firstName').dirty"
              >
                <ion-label
                  id="name"
                  class="contact-input-label"
                  position="stacked"
                  >{{ 'i18n.profilePage.contact.nameInput' | translate }}
                  <span>*</span>
                </ion-label>
                <ion-textarea
                  aria-labelledby="name"
                  (keydown.enter)="pressEnterKey()"
                  class="ion-no-padding"
                  type="text"
                  maxlength="25"
                  autoGrow="true"
                  rows="1"
                  name="firstName"
                  formControlName="firstName"
                  [placeholder]="
                    'i18n.profilePage.contact.firstNamePlaceholder' | translate
                  "
                  (ionInput)="validateValue()"
                >
                </ion-textarea>
              </ion-item>
              <p
                class="error-text"
                *ngIf="contactForm.get('firstName').invalid"
              >
                <span>*</span
                >{{ 'i18n.profilePage.contact.inputRequired' | translate }}
              </p>
            </ion-col>
            <ion-col
              data-cy="last-name-input-field"
              class="contact-input"
              size="12"
              size-md="3.5"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
                [class.error]="contactForm.get('lastName').invalid"
                [class.update]="contactForm.get('lastName').dirty"
              >
                <ion-label
                  id="last-name"
                  class="contact-input-label"
                  position="stacked"
                  >{{ 'i18n.profilePage.contact.lastNameInput' | translate }}
                  <span>*</span>
                </ion-label>
                <ion-textarea
                  aria-labelledby="last-name"
                  (keydown.enter)="pressEnterKey()"
                  class="ion-no-padding"
                  type="text"
                  maxlength="25"
                  autoGrow="true"
                  rows="1"
                  name="lastName"
                  formControlName="lastName"
                  [placeholder]="
                    'i18n.profilePage.contact.lastNamePlaceholder' | translate
                  "
                  (ionInput)="validateValue()"
                >
                </ion-textarea>
              </ion-item>
              <p class="error-text" *ngIf="contactForm.get('lastName').invalid">
                <span>*</span
                >{{ 'i18n.profilePage.contact.inputRequired' | translate }}
              </p>
            </ion-col>
            <ion-col
              data-cy="organization-name-input-field"
              class="contact-input"
              size="12"
              size-md="3.5"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
                [class.error]="contactForm.get('organizationName').invalid"
                [class.update]="contactForm.get('organizationName').dirty"
              >
                <ion-label
                  id="contact"
                  class="contact-input-label"
                  position="stacked"
                  >{{
                    'i18n.profilePage.contact.organizationInput' | translate
                  }}
                </ion-label>
                <ion-textarea
                  aria-labelledby="contact"
                  (keydown.enter)="pressEnterKey()"
                  class="ion-no-padding"
                  type="text"
                  maxlength="50"
                  autoGrow="true"
                  rows="1"
                  name="organizationName"
                  formControlName="organizationName"
                  [placeholder]="
                    'i18n.profilePage.contact.organizationPlaceholder'
                      | translate
                  "
                  (ionInput)="validateValue()"
                >
                </ion-textarea>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row class="ion-justify-content-between">
            <ion-col
              data-cy="notification-email-input-field"
              class="contact-input"
              size="12"
              size-md="3.5"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
                [class.error]="contactForm.get('notificationEmail').invalid"
                [class.update]="contactForm.get('notificationEmail').dirty"
              >
                <ion-label
                  id="email"
                  class="contact-input-label"
                  position="stacked"
                >
                  {{
                    'i18n.profilePage.contact.notificationEmailInput'
                      | translate
                  }}
                  <span>*</span>
                </ion-label>
                <ion-textarea
                  aria-labelledby="email"
                  (keydown.enter)="pressEnterKey()"
                  class="ion-no-padding"
                  type="email"
                  maxlength="80"
                  autoGrow="true"
                  rows="1"
                  name="notificationEmail"
                  formControlName="notificationEmail"
                  [placeholder]="
                    'i18n.profilePage.contact.notificationEmailPlaceholder'
                      | translate
                  "
                  (ionInput)="validateValue()"
                >
                </ion-textarea>
              </ion-item>
              <p
                class="error-text"
                *ngIf="contactForm.get('notificationEmail').invalid"
              >
                <span>*</span
                >{{ 'i18n.profilePage.contact.emailInvalid' | translate }}
              </p>
            </ion-col>
            <ion-col
              data-cy="confirm-email-input-field"
              class="contact-input"
              size="12"
              size-md="3.5"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
                [class.error]="contactForm.errors?.['noMatch']"
                [class.update]="
                  contactForm.get('confirmNotificationEmail').dirty
                "
              >
                <ion-label
                  id="confirm-email"
                  class="contact-input-label"
                  position="stacked"
                >
                  {{
                    'i18n.profilePage.contact.confirmNotificationEmailInput'
                      | translate
                  }}
                  <span>*</span>
                </ion-label>
                <ion-textarea
                  aria-labelledby="confirm-email"
                  (keydown.enter)="pressEnterKey()"
                  class="ion-no-padding"
                  type="email"
                  maxlength="80"
                  autoGrow="true"
                  rows="1"
                  name="confirmNotificationEmail"
                  formControlName="confirmNotificationEmail"
                  [placeholder]="
                    'i18n.profilePage.contact.notificationEmailPlaceholder'
                      | translate
                  "
                  (ionInput)="validateValue()"
                ></ion-textarea>
              </ion-item>
              <p
                data-cy="unmatched-email-error-text"
                class="error-text"
                *ngIf="contactForm.errors?.['noMatch']"
              >
                <span>*</span
                >{{ 'i18n.profilePage.contact.unmatchedEmail' | translate }}
              </p>
            </ion-col>
            <ion-col
              class="contact-input"
              size="12"
              size-md="3.5"
              *appShowSplit="[primaryLanguageSelectionFlag]"
            >
              <ion-item
                class="ion-align-items-start ion-no-padding ion-padding-top"
              >
                <ion-label class="contact-input-label" position="stacked"
                  >{{ 'i18n.profilePage.contact.chooseLanguage' | translate }}
                </ion-label>
                <div
                  id="open-modal"
                  *ngIf="(platformService?.isTouchExperience$ | async) === true"
                  class="ion-no-padding app-language-selection"
                >
                  {{
                    selectedProfileDisplayLang ||
                      'i18n.profilePage.contact.device' | translate
                  }}
                </div>

                <div
                  *ngIf="
                    (platformService?.isTouchExperience$ | async) === false
                  "
                  (click)="openPopover($event)"
                  class="ion-no-padding app-language-selection"
                >
                  {{
                    selectedProfileDisplayLang ||
                      'i18n.profilePage.contact.browser' | translate
                  }}
                </div>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </form>
    </div>
    <div class="footer-buttons">
      <ion-button
        data-cy="save-contact-information-button"
        type="submit"
        [ngClass]="
          isSaveDisable() ? 'usf-fill-disabled-button' : 'usf-fill-green-button'
        "
        expand="block"
        [disabled]="isSaveDisable()"
        (click)="validateSubmit()"
      >
        {{ 'i18n.common.save' | translate }}
      </ion-button>
    </div>
  </ion-card-content>
</ion-card>

<ng-container *ngIf="touchPopoverReady">
  <ion-modal
    trigger="open-modal"
    triggerAction="click"
    class="ion-modal-touch"
    [initialBreakpoint]="1"
    [breakpoints]="[0, 0.5, 1]"
    mode="ios"
  >
    <ng-template>
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-label class="modal-label bold-font-weight">
            {{ 'i18n.common.primary' | translate }}
          </ion-label>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-content-modal-mobile">
        <ion-radio-group (ionChange)="handleLanguageChange($event)">
          <ion-item>
            <ion-radio mode="md" value="none" labelPlacement="start">
              {{ 'i18n.profilePage.contact.none' | translate }}
            </ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio mode="md" value="en" labelPlacement="start">
              {{ 'i18n.profilePage.contact.english' | translate }}
            </ion-radio>
          </ion-item>
          <ion-item>
            <ion-radio mode="md" value="es" labelPlacement="start">
              {{ 'i18n.profilePage.contact.spanish' | translate }}
            </ion-radio>
          </ion-item>
        </ion-radio-group>
      </ion-content>
    </ng-template>
  </ion-modal>
</ng-container>
